import "@sms/design-system/tokens/global.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { apiClient } from "./sdk";

const root = document.getElementById("root");
if (!root) throw new Error("shell: #root missing in index.html");

createRoot(root).render(
  <StrictMode>
    <AuthProvider client={apiClient}>
      <App />
    </AuthProvider>
  </StrictMode>,
);
